module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Login"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "Login_form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loginUser($event)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.$v.email.$error
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('register.field.email')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.email.$error && !_vm.$v.email.required),
      expression: "$v.email.$error && !$v.email.required"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('validation.required')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.$v.password.$error
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('register.field.password')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.password.$error && !_vm.$v.password.required),
      expression: "$v.password.$error && !$v.password.required"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('validation.required')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "Login_form_actions"
  }, [_c('button', {
    staticClass: "button is-info is-fullwidth",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.login')) + "\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-warning is-fullwidth is-hidden-tablet",
    attrs: {
      "to": {
        'name': 'register'
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.register')) + "\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    attrs: {
      "src": require("../assets/img/illus/cards.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "Login_intro"
  }, [_c('p', {
    staticClass: "Login_intro_actions has-text-centered"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('login.no_account')))]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-warning",
    attrs: {
      "to": {
        'name': 'register'
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.register')) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content has-text-centered"
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('login.title')))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.description'))
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    attrs: {
      "title": _vm.$t('title')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo_small.svg"),
      "alt": _vm.$t('title')
    }
  })])], 1)
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.form_text'))
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock_outline")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1671a6cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageLogin.vue
// module id = 349
// module chunks = 9